import { createReducer, on } from '@ngrx/store';
import { Split } from '../../models/split.model';
import * as SplitsActions from './splits.actions';

export interface SplitsState {
  splits: Split[];
  selectedSplit: Split | null;
  loading: boolean;
  error: any;
  pagination: {
    currentPage: number;
    pageSize: number;
    totalItems: number;
  };
}

export const initialState: SplitsState = {
  splits: [],
  selectedSplit: null,
  loading: false,
  error: null,
  pagination: {
    currentPage: 1,
    pageSize: 20,
    totalItems: 0,
  },
};

export const splitsReducer = createReducer(
  initialState,

  // Load Splits
  on(SplitsActions.loadSplits, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(SplitsActions.loadSplitsSuccess, (state, { splits, pagination }) => ({
    ...state,
    splits,
    pagination,
    loading: false,
    error: null,
  })),
  on(SplitsActions.loadSplitsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Load Single Split
  on(SplitsActions.loadSplit, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(SplitsActions.loadSplitSuccess, (state, { split }) => ({
    ...state,
    selectedSplit: split,
    loading: false,
    error: null,
  })),
  on(SplitsActions.loadSplitFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Create Split
  on(SplitsActions.createSplit, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(SplitsActions.createSplitSuccess, (state, { split }) => ({
    ...state,
    splits: [...state.splits, split],
    loading: false,
    error: null,
  })),
  on(SplitsActions.createSplitFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Update Split
  on(SplitsActions.updateSplit, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(SplitsActions.updateSplitSuccess, (state, { split }) => ({
    ...state,
    splits: state.splits.map((s) => (s.id === split.id ? split : s)),
    selectedSplit: split,
    loading: false,
    error: null,
  })),
  on(SplitsActions.updateSplitFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Delete Split
  on(SplitsActions.deleteSplit, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(SplitsActions.deleteSplitSuccess, (state, { id }) => ({
    ...state,
    splits: state.splits.filter((s) => s.id !== id),
    loading: false,
    error: null,
  })),
  on(SplitsActions.deleteSplitFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
